// Gatsby supports TypeScript natively!
import React, { useState } from "react"
import { PageProps, Link, graphql } from "gatsby"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { rhythm } from "../utils/typography"
import '../styles/index.css'


type Data = {
  site: {
    siteMetadata: {
      title: string
    }
  }
  allMarkdownRemark: {
    edges: {
      node: {
        excerpt: string
        frontmatter: {
          title: string
          date: string
          description: string
          tag: string
          cover: string
        }
        fields: {
          slug: string
        }
      }
    }[]
  }
}

interface Query {
  filteredData: any;
  query: string
}

const Series = ({ data, location }: PageProps<Data>) => {
  const allPosts = data.allMarkdownRemark.edges
  const emptyQuery = ""
  const [state, setState] = useState<Query>({ filteredData: [], query: emptyQuery })
  const handleInputChange = e => {
    console.log(e.target.value);
    const query = e.target.value;
    const posts = data.allMarkdownRemark.edges || []
    const filteredData = posts.filter(post => {
      const { description, title } = post.node.frontmatter
      return (
        description.toLowerCase().includes(query.toLowerCase()) ||
        title.toLowerCase().includes(query.toLowerCase())
      )
    })
    setState({
      query,
      filteredData,
    })
  }
  const { filteredData, query } = state;
  const hasSearchResults = filteredData && query !== emptyQuery
  const posts = hasSearchResults ? filteredData : allPosts;
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="All posts" />
      <Bio/>
      <div className="searchBox"
        style={{
          display: `flex`,
          marginBottom: rhythm(2.5),
          borderRadius: `10px`,
          backgroundColor: "var(--bg)"
        }}
      >
        <input
        style={{ borderRadius: 50, color: `var(--searchText)` }}
          className="searchInput"
          type="text"
          aria-label="Search"
          placeholder="Type to filter posts..."
          onChange={handleInputChange}
        />
      </div>
      <p style={{ fontWeight: 'bolder', fontSize: "700", color: `var(--date)` }}>RECENTLY PUBLISHED</p>
      {posts.map(({ node }) => {
        const title = node.frontmatter.title || node.fields.slug
        return (
          <article key={node.fields.slug}>
            <p className="post">
              <header>
                <h2 style={{marginBottom: rhythm(0 / 4), margin: 0}}>
                <img src={node.frontmatter.cover} style={{ padding: 0, borderRadius: 20, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }} />
                  <Link style={{ boxShadow: `none` }} to={node.fields.slug}>
                    {title}
                  </Link>
                </h2>
                <small style={{ fontWeight: "bold" , color: `var(--date)`}}>{node.frontmatter.date}</small>
                <p style={{ marginTop: rhythm(1/4) }} >{node.frontmatter.description}</p>
              </header>
            </p>
          </article>
        )
      })}
    </Layout>
  )
}

export default Series

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            tag
            cover
          }
        }
      }
    }
  }
`
